import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_STATISTICS = "/api/statistics"

export async function getStatistics(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_STATISTICS
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getStatistic(id) {
  let url = REACT_APP_API_URL + ENDPOINT_STATISTICS + "/" + id
  return await getObject(url)
}

export async function putStatistic(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_STATISTICS + "/" + id
  return await putObject(url, putValues)
}

export async function patchStatistic(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_STATISTICS + "/" + id
  return await patchObject(url, patchValues)
}

export async function postStatistic(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_STATISTICS
  return await postObject(url, postValues)
}
